import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BandwidthE911Dlr, BandwidthE911DlrRef } from '../../../shared/models/generated/ziroModels';
import { Nvp } from '../../../shared/models/nvp';
import { AuditHeaderService } from '../../../shared/services/audit-header.service';
import { HttpOptions } from '../../../shared/resources/abstract/model.resource.abstract';

@Injectable()
export class BandwidthE911DlrsResource {
  protected http = inject(HttpClient);
  private _auditHeaderService = inject(AuditHeaderService);

  get(tenantId: string | number, endpointId: string): Observable<BandwidthE911Dlr> {
    return this.http.get<BandwidthE911Dlr>(
      `/services/microsoft/macs/tenants/${tenantId}/bandwidth-e911-dlrs/${endpointId}`,
    );
  }

  post(tenantId: string | number, body: BandwidthE911Dlr, auditTags?: Nvp[]): Observable<BandwidthE911DlrRef> {
    const httpOptions = this._buildHttpOptions(auditTags);
    return this.http.post<BandwidthE911DlrRef>(
      `/services/microsoft/macs/tenants/${tenantId}/bandwidth-e911-dlrs`,
      body,
      httpOptions,
    );
  }

  put(tenantId: string | number, body: BandwidthE911Dlr): Observable<void> {
    return this.http.put<void>(`/services/microsoft/macs/tenants/${tenantId}/bandwidth-e911-dlrs/${body.id}`, body);
  }

  delete(tenantId: string | number, endpointId: string, auditTags?: Nvp[]): Observable<void> {
    const httpOptions = this._buildHttpOptions(auditTags);
    return this.http.delete<void>(
      `/services/microsoft/macs/tenants/${tenantId}/bandwidth-e911-dlrs/${endpointId}`,
      httpOptions,
    );
  }

  private _buildHttpOptions(auditTags: Nvp[]): HttpOptions | object {
    return auditTags ? { headers: this._auditHeaderService.buildHeader(auditTags) } : {};
  }
}
